import { render, staticRenderFns } from "./AIAudiences.vue?vue&type=template&id=7205d484&scoped=true"
import script from "./AIAudiences.vue?vue&type=script&lang=js"
export * from "./AIAudiences.vue?vue&type=script&lang=js"
import style0 from "./AIAudiences.vue?vue&type=style&index=0&id=7205d484&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7205d484",
  null
  
)

export default component.exports